/**
 * Mega Menu Dropdown - Tab Switching Functionality
 * Minimal vanilla JS for accessibility and tab switching
 */

class MegaMenuDropdown {
  constructor(element) {
    this.element = element;
    this.tabs = element.querySelectorAll('[role="tab"]');
    this.panels = element.querySelectorAll('[role="tabpanel"]');
    this.currentTab = 0;
    this.hasInteracted = false;

    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.switchTab(index));
      tab.addEventListener('mouseenter', () => {
        if (!this.hasInteracted && index === 0) return;
        this.hasInteracted = true;
        this.switchTab(index);
      });
      tab.addEventListener('focus', () => this.switchTab(index));
      tab.addEventListener('keydown', (e) => this.handleKeydown(e, index));
    });
  }

  switchTab(newIndex) {
    if (newIndex === this.currentTab) return;

    // Update tab states
    this.tabs.forEach((tab, index) => {
      const isActive = index === newIndex;
      tab.setAttribute('aria-selected', isActive);
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
      tab.classList.toggle('is-active', isActive);
    });

    // Update panel states
    this.panels.forEach((panel, index) => {
      const isActive = index === newIndex;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('aria-hidden');
      } else {
        panel.setAttribute('aria-hidden', 'true');
      }
    });

    this.currentTab = newIndex;
  }

  handleKeydown(e, currentIndex) {
    let newIndex = currentIndex;

    switch (e.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        e.preventDefault();
        newIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowUp':
      case 'ArrowLeft':
        e.preventDefault();
        newIndex = currentIndex === 0 ? this.tabs.length - 1 : currentIndex - 1;
        break;
      case 'Home':
        e.preventDefault();
        newIndex = 0;
        break;
      case 'End':
        e.preventDefault();
        newIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    this.switchTab(newIndex);
    this.tabs[newIndex].focus();
  }
}

// Initialize mega menu dropdowns
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-js-mega-menu-dropdown]').forEach(element => {
    new MegaMenuDropdown(element);
  });
});
